import { render } from "./SystemError.vue?vue&type=template&id=1c0a584f"
import script from "./SystemError.vue?vue&type=script&lang=js"
export * from "./SystemError.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/SystemError.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c0a584f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c0a584f', __exports__)) {
    api.reload('1c0a584f', __exports__)
  }
  
  module.hot.accept("./SystemError.vue?vue&type=template&id=1c0a584f", () => {
    api.rerender('1c0a584f', render)
  })

}


export default __exports__